// extracted by mini-css-extract-plugin
module.exports = {"container":"partials-light-box-container","opened":"partials-light-box-opened"};